import * as RegionsSideMenuActions from './regions-side-menu.actions';
import type { RegionsSideMenuState } from './regions-side-menu.models';

const { RegionsSideMenuActionsTypes } = RegionsSideMenuActions;

type RegionsSideMenuActionsFunctions = Omit<typeof RegionsSideMenuActions, 'RegionsSideMenuActionsTypes'>;
type ActionsResponses = ReturnType<RegionsSideMenuActionsFunctions[keyof RegionsSideMenuActionsFunctions]>;

const initialState: RegionsSideMenuState = {
  hoveredRegion: null
};

export default (state = initialState, action: ActionsResponses): RegionsSideMenuState => {
  switch (action.type) {
    case RegionsSideMenuActionsTypes.SET_HOVERED_REGION:
      return {
        ...state,
        hoveredRegion: action.payload
      };
    default:
      return state;
  }
};
